import logo from '@/assets/logo.png';
import Image from 'next/image';

export default function FaIcon({ style }: { style?: string }) {
    return (
        <Image
            src={logo}
            alt="درمان شیرین"
            width={170}
            height={170}
            fetchPriority="high"
            loading="eager"
            className={style}
        />
    );
}
